import React from 'react';
import { Outlet } from 'react-router-dom';
import SiteHeader from '@/components/SiteHeader';
import SiteFooter from '@/components/SiteFooter';
import StickyContact from '@/components/StickyContact';
import JsonLd from '@/components/JsonLd';

export default function SiteLayout() {
  return (
    <>
      <JsonLd />
      <SiteHeader />
      <main className="min-h-screen bg-[#F4F5F7]">
        <Outlet />
      </main>
      <SiteFooter />
      <StickyContact />
    </>
  );
}
